import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Col, Well, Collapse, Button } from 'react-bootstrap'

import ProjectFilter from './ProjectFilter'
import DeliverablesFilter from './DeliverablesFilter'

class ProjectFilterContainer extends Component {
  state = {
    smallScreenFiltersOpen: false,
  }

  toggleOpen = () => this.setState({ smallScreenFiltersOpen: !this.state.smallScreenFiltersOpen })

  render() {

    const { deliverablesView } = this.props

    return (
      <div id="ProjectFilter">

        <Col xsHidden smHidden id="large-device">
          <Well>
            {deliverablesView ?
              <DeliverablesFilter history={this.props.history} />
              :
              <ProjectFilter history={this.props.history} />
            }
          </Well>
        </Col>

        <Col mdHidden lgHidden>
          <div id="filter-display-button">
            <Button onClick={this.toggleOpen}>
              Filters
            </Button>
          </div>
          <Collapse in={this.state.smallScreenFiltersOpen}>
            <Well>
              {deliverablesView ?
                <DeliverablesFilter history={this.props.history} />
                :
                <ProjectFilter history={this.props.history} />
              }
            </Well>
          </Collapse>
        </Col>

      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    deliverablesView: state.manageProjectFilters.deliverablesView,
  }
}

export default connect(mapStateToProps)(ProjectFilterContainer)



// WEBPACK FOOTER //
// ./src/routes/projects/components/ProjectFilterContainer.js